import { returnContentStringFaqAnswer } from 'utils/shared'

export function buildFaqJsonLd(faqSets = [], onInvalid = () => {}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqSets.map((set) => {
      const answer = returnContentStringFaqAnswer(set?.answer) ?? ''
      const question = returnContentStringFaqAnswer(set?.question) ?? ''
      if (!question || !answer) {
        onInvalid(question, answer)
        return null
      }
      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
        },
      }
    }),
  }
}
